// extracted by mini-css-extract-plugin
export default {"menu":"menu_menu__GSIfe","header":"menu_header__y0vkV","productGrid":"menu_productGrid__TvDeP","item":"menu_item__b7AZZ","floatingButtons":"menu_floatingButtons__A4Ro6"};